export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9165.fa3767a6.jpg";